const fontWeight = {
    fontWeight: 600,
};

export const metricsProps = {
    basic: {
        impressions: {
            metric: "Impressions",
            description: "Количество показов рекламного объявления.",
            style: fontWeight,
        },
        dailyUniqueUsers: {
            metric: "Daily U. U. (Daily unique users)",
            description: "Сумма уникальных пользователей, которым показывалась реклама за день.",
            style: fontWeight,
        },
        uniqueUsers: {
            metric: "U. U. (Unique users)",
            description: "Количество пользователей (файлов cookie), которым показывалась реклама с начала кампании, или сумма уникальных пользователей, которым показывалась реклама ежемесячно в течение кампании продолжительностью более 90 дней или неизвестной продолжительности (без даты окончания кампании).",
            style: fontWeight,
        },
        clicks: {
            metric: "Clicks",
            description: "Количество кликов по рекламному объявлению.",
            style: fontWeight,
        },
        dailyUniqueClicks: {
            metric: "Daily U. clicks (Daily unique clicks )",
            description: "Сумма уникальных пользователей, совершивших клики за день.",
            style: fontWeight,
        },
        uniqueClicks: {
            metric: "U. clicks (Unique clicks)",
            description: "Количество уникальных пользователей, совершивших клик с начала кампании, или сумма уникальных пользователей, совершивших клик за месяц в течение кампании продолжительностью более 90 дней или неизвестной продолжительности (без даты окончания кампании).",
            style: fontWeight,
        },
        ctrPercent: {
            metric: "CTR %",
            description: "Процент кликов по отношению к количеству показов.",
            style: fontWeight,
        },
        reachImpressionsClicksConversions: {
            metric: "Reach Impressions / Clicks / Conversions",
            description: "Уникальное количество показов / кликов / конверсий",
            style: fontWeight,
        },
        uniqueFrequencyDailyUniqueFrequency: {
            metric: "Unique frequency / Daily unique frequency",
            description: "Среднее количество показов рекламы на одного уникального пользователя за весь период кампании / среднее количество показов рекламы на одного уникального пользователя в течение одного дня.",
            style: fontWeight,
        },
        nonFilteredImpressionsNonFilteredClicks: {
            metric: "Non-Filtered Impressions / Non-filtered Clicks",
            description: "Количество показов или кликов, оставшихся после применения фильтрации по списку ботов IAB и / или алгоритма,  учитывающим дублирующиеся показы / клики, совершенные в течение 5 секунд.",
            style: fontWeight,
        },
    },
    video: {
        autoplay: {
            metric: "Autoplay",
            description: "Автоматическое воспроизведение.",
            style: fontWeight,
        },
        progressPercent: {
            metric: "Progress (25%, 50%, 75%, 100%)",
            description: "Прогресс просмотра видео (25%, 50%, 75%, 100%).",
            style: fontWeight,
        },
        dailyUVideoProgress: {
            metric: "Daily U. video progress",
            description: "Ежедневное количество уникальных пользователей, достигших заданного прогресса просмотра видео.",
            style: fontWeight,
        },
        uVideoProgressPercent: {
            metric: "U. video progress (25%, 50%, 75%, 100%)",
            description: "Количество уникальных пользователей, достигших заданного прогресса просмотра видео.",
            style: fontWeight,
        },
        progress30s: {
            metric: "Progress 30s",
            description: "Просмотр видео продолжительностью не менее 30 секунд (используется для версии VAST 3.0).",
            style: fontWeight,
        },
        loop: {
            metric: "Loop",
            description: "Зацикленное воспроизведение. Количество раз, когда видео достигает своей конечной точки и начинается заново. Символ # следует заменить числом повторов видео. Это событие должно срабатывать, когда видео воспроизводится дважды. Первый цикл должен быть: video_loop_1.",
            style: fontWeight,
        },
        playPauseCloses: {
            metric: "Play / pause / closes",
            description: "Пользователь активировал кнопки воспроизведения / паузы / закрытия видео.",
            style: fontWeight,
        },
        muteUnmute: {
            metric: "Mute / unmute",
            description: "Пользователь активировал управление звуком и включил или выключил звук видео.",
            style: fontWeight,
        },
        fullscreen: {
            metric: "Fullscreen",
            description: "Пользователь активировал элемент управления, позволяющий расширить видеоплеер до полноэкранного режима.",
            style: fontWeight,
        },
        creativeView: {
            metric: "Creative view",
            description: "Просмотр видеоролика.",
            style: fontWeight,
        },
        acceptInvitation: {
            metric: "Accept invitation",
            description: "Пользователь активировал элемент управления, который запустил дополнительную часть рекламного материала.",
            style: fontWeight,
        },
        closeRate: {
            metric: "Close rate",
            description: "Показатель закрытия видео (доля закрытий).",
            style: fontWeight,
        },
        vtr: {
            metric: "VTR",
            description: "Коэффициент досмотров (доля просмотров).",
            style: fontWeight,
        },
        skip: {
            metric: "Skip",
            description: "Пользователь активировал кнопку «Пропустить», чтобы пропустить рекламный ролик.",
            style: fontWeight,
        },
        trueview: {
            metric: "Trueview",
            description: "Количество событий «engaged_view» или «engagedView».",
            style: fontWeight,
        },
    },
    performance: {
        conversions: {
            metric: "Conversions",
            description: "Количество выполненных конверсий.",
            style: fontWeight,
        },
        postClickConversions: {
            metric: "PC conv. (Post-click conversions)",
            description: "Количество конверсий, совершенных по клику.",
            style: fontWeight,
        },
        postEventConversions: {
            metric: "PE conv. (Post-event conversions)",
            description: "Количество конверсий, совершенных в результате события, то есть после взаимодействия пользователя с рекламой.",
            style: fontWeight,
        },
        postVisibilityConversions: {
            metric: "PV conv. (Post-visibility conversions)",
            description: "Количество конверсий, совершенных в рамках определенного уровня видимости объявления, с которым взаимодействовал пользователь. Этот тип конверсии доступен только в том случае, если модуль «Видимость» активирован в учетной записи WCM.",
            style: fontWeight,
        },
        postImpressionConversions: {
            metric: "PI conv.(Post-impression conversions)",
            description: "Количество конверсий, совершенных в результате показа, то есть после того, как пользователь увидел объявление. Если в аккаунте WCM активирован модуль «Видимость», то конверсиями после показа считаются конверсии, совершенные после того, как пользователь увидел объявление, выходящее за пределы установленного порога видимости.",
            style: fontWeight,
        },
        dailyUConv: {
            metric: "Daily U.conv.",
            description: "Сумма уникальных пользователей, совершивших конверсию за день.",
            style: fontWeight,
        },
        dailyUniqueConversions: {
            metric: "Daily PC U.conv. , Daily PE U.conv., Daily PV U.conv., Daily PI U.conv. (Daily unique conversions)",
            description: "Сумма уникальных пользователей, совершивших конверсию за день, с разбивкой по типам конверсий.",
            style: fontWeight,
        },
        totalUntrackedConversions: {
            metric: "Total untracked conversions",
            description: "Количество конверсий, не атрибуцированных к рекламной кампании.",
            style: fontWeight,
        },
        conversionRateVersusImpression: {
            metric: "Conversion rate versus impression",
            description: "Процент конверсий по отношению к количеству показов.",
            style: fontWeight,
        },
        conversionRateVersusClick: {
            metric: "Conversion rate versus click",
            description: "Процент конверсий по отношению к количеству кликов.",
            style: fontWeight,
        },
        contributions: {
            metric: "Contributions",
            description: "Количество действий, выполненных пользователями до конверсии (исключая действие, к которому была отнесена конверсия).",
            style: fontWeight,
        },
        funnel: {
            metric: "Funnel 1 - 5",
            description: "Количество просмотров страниц на каждом этапе воронки продаж.",
            style: fontWeight,
        },
        postClickConversionRateVersusClicks: {
            metric: "PC conv. rate / clicks (Post-click conversion rate versus clicks)",
            description: "Процент конверсий после клика по отношению к общему количеству кликов.",
            style: fontWeight,
        },
        postClickConversionRateVersusEvents: {
            metric: "PC conv. rate /events (Post-click conversion rate versus events)",
            description: "Процент конверсий после клика по отношению к общему количеству событий.",
            style: fontWeight,
        },
        postClickConversionRateVersusVisibilities: {
            metric: "PC conv. rate / visibility (Post-click conversion rate versus visibilities)",
            description: "Процент конверсий после клика по отношению к общему количеству видимых показов.",
            style: fontWeight,
        },
        postClickConversionRateVersusImpressions: {
            metric: "PC conv. rate / imp. (Post-click conversion rate versus impressions)",
            description: "Процент конверсий после клика по отношению к общему количеству показов.",
            style: fontWeight,
        },
        postEventConversionRateVersusEvents: {
            metric: "PE conv. rate / events (Post-event conversion rate versus events)",
            description: "Процент конверсий после события  по отношению к общему количеству событий.",
            style: fontWeight,
        },
        postEventConversionRateVersusVisibilty: {
            metric: "PE conv. rate / visibility (Post-event conversion rate versus visibilty)",
            description: "Процент конверсий после события по отношению к общему количеству  видимых показов.",
            style: fontWeight,
        },
        postEventConversionRateVersusImpressions: {
            metric: "PE conv. rate / imp. (Post-event conversion rate versus impressions)",
            description: "Процент конверсий после события по отношению к общему количеству показов.",
            style: fontWeight,
        },
        postVisibilityConversionRateVersusVisibilities: {
            metric: "PV conv. rate / visibility (Post-visibility conversion rate versus visibilities)",
            description: "Процент конверсий после видимого показа рекламы по отношению к общему количеству видимых показов.",
            style: fontWeight,
        },
        postVisibilityConversionRateVersusImpresions: {
            metric: "PV conv. rate / imp. (Post-visibilty conversion rate versus impresions)",
            description: "Процент конверсий после видимого показа рекламы в зависимости от общего количества показов.",
            style: fontWeight,
        },
        postImpressionConversionRateVersusImpressions: {
            metric: "PI conv. rate / imp. (Post-impression conversion rate versus impressions)",
            description: "Процент конверсий после показа в зависимости от общего количества показов.",
            style: fontWeight,
        },
        percentageOfPostClickConversionsOver60min: {
            metric: "% of PC conv. < 60 min (Percentage of Post-click conversions over 60 min)",
            description: "Процент конверсий, совершенных в течение 60 минут после клика, по отношению к общему числу конверсий.",
            style: fontWeight,
        },
        newCustomers: {
            metric: "New customers",
            description: "Количество новых клиентов.  Этот показатель доступен, если в WCM задан параметр «is-client» в теге конверсии.  Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        averageTimeToConversion: {
            metric: "Average time to conversion",
            description: "Среднее время (в днях и часах) между последним действием, приведшим к конверсии (атрибуция), и самой конверсией.",
            style: fontWeight,
        },
        averageTimeBetweenFunnelSteps: {
            metric: "Average time between funnel steps",
            description: "Среднее время (в днях и часах) между этапами воронки.",
            style: fontWeight,
        },
        n1parameters: {
            metric: "N1 param. (N1 parameters)",
            description: "Сумма значений, полученных с помощью пользовательского числового параметра («N»).",
            style: fontWeight,
        },
        t1parameters: {
            metric: "T1 param. (T1 parameters)",
            description: "Сумма значений, полученных с помощью настраиваемого буквенно-цифрового параметра («Т»).",
            style: fontWeight,
        },
        freeParameters: {
            metric: "Free param. (Free Parameters)",
            description: "Сумма значений, полученных с помощью  свободно назначаемого пользовательского числового параметра.",
            style: fontWeight,
        },
    },
    visibility: {
        viewableImpBanner: {
            metric: "Viewable imp. (banner)",
            description: "Количество видимых показов (для баннерных кампаний).",
            style: fontWeight,
        },
        dailyUViewsDailyUniqueViews: {
            metric: "Daily U. views (Daily unique views)",
            description: "Сумма уникальных видимых показов за день  (для баннерных кампаний).",
            style: fontWeight,
        },
        uViewsUniqueViews: {
            metric: "U. views (Unique views)",
            description: "Количество уникальных пользователей (cookies), которым была показана видимая реклама:  за весь период кампании, если её длительность до 90 дней;  либо суммарное количество месячных уникальных пользователей, если длительность кампании более 90 дней или неизвестна (дата окончания кампании не задана).",
            style: fontWeight,
        },
        views5sec: {
            metric: "Views 5 sec",
            description: "Количество показов, при которых объявление было видимо как минимум на 50% своей площади в течение не менее 5 секунд.",
            style: fontWeight,
        },
        totalViewabilityTime: {
            metric: "Total viewability time",
            description: "Общее время видимости объявлений по всем показам, для которых зафиксированы данные о видимости (unload).",
            style: fontWeight,
        },
        measurableImpressionsBanneravgViewabilityTime : {
            metric: "Avg. viewability time",
            description: "Среднее время видимости на одно событие видимости.",
            style: fontWeight,
        },
        clickRateVsViewableImpBanner: {
            metric: "Click rate vs Viewable impression (banner)",
            description: "Соотношение количества кликов к количеству просмотров.",
            style: fontWeight,
        },
        cpv: {
            metric: "CPV",
            description: "Стоимость за видимый показ. Метрика доступна в отчётах только в случае, если стоимость настроена в параметрах кампании.",
            style: fontWeight,
        },
        viewabilityRateOlv: {
            metric: "Viewability rate (OLV)",
            description: "Доля видимых показов от общего количества показов в видеокампании.",
            style: fontWeight,
        },
        viewabilityRateProgressPercentOlv: {
            metric: "Viewability rate progress 25%, 50%, 75%, 100% OLV",
            description: "Процент видимости объявления на странице при старте и при просмотре видео до 25%, 50%, 75% и 100%.",
            style: fontWeight,
        },
        measurableImpressionsBanner: {
            metric: "Measurable impressions (banner)",
            description: "Показы, для которых была измерена видимость.",
            style: fontWeight,
        },
        viewabilityRateBanner: {
            metric: "Viewability rate (banner)",
            description: "Соотношение видимых показов к количеству загрузок креатива.",
            style: fontWeight,
        },
        viewabilityMeasurementRateBanner: {
            metric: "Viewability measurement rate (banner)",
            description: "(События unload / показы) x 100.",
            style: fontWeight,
        },
        viewableMrc : {
            metric: "Viewable MRC ",
            description: "Показы, при которых не менее 50% видеорекламы было видимо в течение как минимум 2 секунд.",
            style: fontWeight,
        },
        unviewableMrc: {
            metric: "Unviewable MRC",
            description: "Количество показов, для которых мероприятие MRC не произошло.",
            style: fontWeight,
        },
        viewabilityMrcRate : {
            metric: "Viewability MRC rate ",
            description: "Доля MRC-видимых показов от общего количества показов, для которых могла быть измерена MRC-видимость.",
            style: fontWeight,
        },
    },
    customEvents: {
        visibility: {
            metric: "ВИДИМОСТЬ",
            description: "",
            style: {
                fontWeight: fontWeight,
                color: "#c1002a",
            },
        },
        MRCUndetermined: {
            metric: "MRCUndetermined",
            description:
                "Рекламный юнит не может посчитать видимость на странице (см. описание Undetermined выше), соответственно и определение MRC невозможно",
            style: fontWeight,
        },
        MRCUnviewable: {
            metric: "MRCUnviewable",
            description: "Событие MRC не наступило. При этом рекламный юнит может посчитать видимость на странице",
            style: fontWeight,
        },
        MRCViewable: {
            metric: "MRCViewable",
            description: "Событие MRC наступило. Плеер был виден на 50% и более втечении 2-х последовательных секунд",
            style: fontWeight,
        },
        sound: {
            metric: "ЗВУК",
            description: "",
            style: {
                fontWeight: fontWeight,
                color: "#c1002a",
            },
        },
        volume: {
            metric: "Volume",
            description: "Любое изменение громкости плеера",
            style: fontWeight,
        },
        initiallyMuted: {
            metric: "Initially muted (включается по запросу)",
            description: "Звук в ролике изначально отключен, а ролик запущен. (=старт ролика без звука)",
            style: fontWeight,
        },
        initiallyUnmuted: {
            metric: "Initially unmuted (включается по запросу)",
            description: "Звук в ролике по умолчанию включен на старте (=старт ролика со звуком)",
            style: fontWeight,
        },
        hearness: {
            metric: "СЛЫШИМОСТЬ",
            description: "",
            style: {
                fontWeight: fontWeight,
                color: "#c1002a",
            },
        },
		audible: {
            metric: "Audible",
            description: "2 последовательные секунды у пользователя должен быть включен звук (не mute и громкость больше 0)",
            style: fontWeight,
        },
		inaudible: {
            metric: "Inaudible",
            description: "Если условие для «Audible» со звуком не выполняется, то по окончании ролика в статистику записывается “Inaudible”",
            style: fontWeight,
        },
        adVideoFirstQuartileAudible: {
            metric: "AdVideoFirstQuartileAudible (включается по запросу)",
            description: "Звук включен на первом квартиле ролика",
            style: fontWeight,
        },
        adVideoFirstQuartileInaudible: {
            metric: "AdVideoFirstQuartileInaudible (включается по запросу)",
            description: "Звук выключен на первом квартиле ролика",
            style: fontWeight,
        },
        adVideoMidpointAudible: {
            metric: "AdVideoMidpointAudible (включается по запросу)",
            description: "Звук включен на втором квартиле ролика",
            style: fontWeight,
        },
        adVideoMidpointInaudible: {
            metric: "AdVideoMidpointInaudible (включается по запросу)",
            description: "Звук выключен на втором квартиле ролика",
            style: fontWeight,
        },
        adVideoThirdQuartileAudible: {
            metric: "AdVideoThirdQuartileAudible (включается по запросу)",
            description: "Звук включен на третьем квартиле ролика",
            style: fontWeight,
        },
        adVideoThirdQuartileInaudible: {
            metric: "AdVideoThirdQuartileInaudible (включается по запросу)",
            description: "Звук выключен на третьем квартиле ролика",
            style: fontWeight,
        },
        adVideoCompleteAudible: {
            metric: "AdVideoCompleteAudible (включается по запросу)",
            description: "Звук включен на четвертом квартиле ролика",
            style: fontWeight,
        },
        adVideoCompleteInaudible: {
            metric: "AdVideoCompleteInaudible (включается по запросу)",
            description: "Звук выключен на четвертом квартиле ролика",
            style: fontWeight,
        },
        sizes: {
            metric: "РАЗМЕР ПЛЕЕРОВ",
            description: "",
            style: {
                fontWeight: fontWeight,
                color: "#c1002a",
            },
        },
        player_0_260: {
            metric: "player_0_260",
            description: "Ширина плеера менее 261 px",
            style: fontWeight,
        },
        player_261_320: {
            metric: "player_261_320",
            description: "Ширина плеера от 261 до 320 px",
            style: fontWeight,
        },
        player_321_380: {
            metric: "player_321_380",
            description: "Ширина плеера от 321 до 380 px",
            style: fontWeight,
        },
        player_381_400: {
            metric: "player_381_400",
            description: "Ширина плеера от 381 до 400 px",
            style: fontWeight,
        },
        player_401_480: {
            metric: "player_401_480",
            description: "Ширина плеера от 401 до 480 px",
            style: fontWeight,
        },
        player_481_720: {
            metric: "player_481_720",
            description: "Ширина плеера от 481 до 720 px",
            style: fontWeight,
        },
        player_721_960: {
            metric: "player_721_960",
            description: "Ширина плеера от 721 до 960 px",
            style: fontWeight,
        },
        player_more_961: {
            metric: "player_more_961",
            description: "Ширина плеера более 960 px",
            style: fontWeight,
        }
    },
    verification: {
        trueImpressions: {
            metric: "True impressions",
            description: "Количество показов без учета IVT-показов",
            style: fontWeight,
        },
        trueClicks: {
            metric: "True clicks",
            description: "Количество кликов без учета IVT-кликов",
            style: fontWeight,
        },
        ivtClicks: {
            metric: "IVT clicks",
            description: "Количество недействительных кликов (GIVT-клики + SIVT-клики)",
            style: fontWeight,
        },
        ivtImpressions: {
            metric: "IVT impressions",
            description: "Количество недействительных показов (GIVT-показы + SIVT-показы)",
            style: fontWeight,
        },
        givtImpression: {
            metric: "GIVT Impression",
            description: "Количество недействительных показов (все категории)",
            style: fontWeight,
        },
        givtImpressionPercent: {
            metric: "GIVT Impression %",
            description: "(Количество показов GIVT / Общее количество показов) x 100%",
            style: fontWeight,
        },
        givtClicks: {
            metric: "GIVT clicks",
            description: "Количество кликов GIVT (клики без показов + повторные клики)",
            style: fontWeight,
        },
        knownInvalidImpression: {
            metric: "Known invalid impression",
            description: "Сумма показов из черного списка известных IP-адресов дата-центров и хостинг-провайдеров (Amazon, Google, Microsoft и др.)",
            style: fontWeight,
        },
        knownInvalidClick: {
            metric: "Known invalid click",
            description: "Сумма кликов из черного списка известных IP-адресов дата-центров и хостинг-провайдеров (Amazon, Google, Microsoft и др.)",
            style: fontWeight,
        },
        knownInvalidConversion: {
            metric: "Known invalid conversion",
            description: "Сумма атрибуцированных к кампании конверсий из черного списка известных IP-адресов дата-центров и хостинг-провайдеров (Amazon, Google, Microsoft и др.)",
            style: fontWeight,
        },
        crawlerImpession: {
            metric: "Crawler impession",
            description: "Сумма показов с рекламным трафиком, генерируемым законными (т.е. не мошенническими) веб-сканерами, парсерами и другими автоматизированными сервисами, будь то системы индексации, инструменты просмотра ссылок (например, в мессенджерах) или аналогичные решения",
            style: fontWeight,
        },
        crawlerClicks: {
            metric: "Crawler clicks",
            description: "Сумма кликов с рекламным трафиком, генерируемым законными (т.е. не мошенническими) веб-сканерами, парсерами и другими автоматизированными сервисами, будь то системы индексации, инструменты просмотра ссылок (например, в мессенджерах) или аналогичные решения",
            style: fontWeight,
        },
        crawlerConversion: {
            metric: "Сrawler conversion",
            description: "Сумма атрибуцированных к кампании конверсий с рекламным трафиком, генерируемым законными (т.е. не мошенническими) веб-сканерами, парсерами и другими автоматизированными сервисами, будь то системы индексации, инструменты просмотра ссылок (например, в мессенджерах) или аналогичные решения",
            style: fontWeight,
        },
        invalidSizePlacements: {
            metric: "Invalid size placements",
            description: "Количество показов с небольшими, едва заметными или невидимыми рекламными блоками (0x0 и 1x1)",
            style: fontWeight,
        },
        nonBrowserImpression: {
            metric: "Non-browser impression",
            description: "Количество показов с рекламным трафиком, которое определяется наличием небраузерных (или не основанных на браузере) HTTP-заголовков — то есть заголовков, указывающих на то, что запрос был инициирован не обычным браузером пользователя, а техническим средством, таким как программный скрипт или специализированный инструмент. На основе списка браузеров IAB.",
            style: fontWeight,
        },
        nonBrowserClicks: {
            metric: "Non-browser clicks",
            description: "Количество кликов с рекламным трафиком, которое определяется наличием небраузерных (или не основанных на браузере) HTTP-заголовков — то есть заголовков, указывающих на то, что запрос был инициирован не обычным браузером пользователя, а техническим средством, таким как программный скрипт или специализированный инструмент. На основе списка браузеров IAB.",
            style: fontWeight,
        },
        nonBrowserConversion: {
            metric: "Non-browser conversion",
            description: "Количество атрибуцированных к кампании конверсий с рекламным трафиком, которое определяется наличием небраузерных (или не основанных на браузере) HTTP-заголовков — то есть заголовков, указывающих на то, что запрос был инициирован не обычным браузером пользователя, а техническим средством, таким как программный скрипт или специализированный инструмент. На основе списка браузеров IAB.",
            style: fontWeight,
        },
        impressionWithExcessiveActivity: {
            metric: "Impression with excessive activity",
            description: "Количество показов рекламного трафика характеризуется аномально высокой частотой активности, которая выходит за рамки типичного поведения реальных пользователей. Чрезмерная активность может быть определена либо на уровне отдельного пользователя (userId), либо на уровне IP-адреса, диапазона IP-адресов, пользовательского агента, кампании, отдельного источника трафика или различных их комбинаций. Пороговые значения определяются верификатором с учетом специфики трафика (например, для VPN-сервисов возможно большее количество действий на IP-адрес)",
            style: fontWeight,
        },
        clickWithExcessiveActivity: {
            metric: "Click with excessive activity",
            description: "Количество кликов с рекламным трафиком характеризуется аномально высокой частотой активности, которая выходит за рамки типичного поведения реальных пользователей. Чрезмерная активность может быть определена либо на уровне отдельного пользователя (userId), либо на уровне IP-адреса, диапазона IP-адресов, пользовательского агента, кампании, отдельного источника трафика или различных их комбинаций. Пороговые значения определяются верификатором с учетом специфики трафика (например, для VPN-сервисов возможно большее количество действий на IP-адрес)",
            style: fontWeight,
        },
        conversionsWithExcessiveActivity: {
            metric: "Conversions with excessive activity",
            description: "Количество конверсий с рекламным трафиком характеризуется аномально высокой частотой активности, которая выходит за рамки типичного поведения реальных пользователей. Чрезмерная активность может быть определена либо на уровне отдельного пользователя (userId), либо на уровне IP-адреса, диапазона IP-адресов, пользовательского агента, кампании, отдельного источника трафика или различных их комбинаций. Пороговые значения определяются верификатором с учетом специфики трафика (например, для VPN-сервисов возможно большее количество действий на IP)",
            style: fontWeight,
        },
        clicksWithoutImpressions: {
            metric: "Clicks without impressions",
            description: "Позволяет выявлять аномалии в рекламных кампаниях, когда клики регистрируются, но данные о показах отсутствуют",
            style: fontWeight,
        },
        repeatedClicks: {
            metric: "Repeated clicks",
            description: "Несколько кликов по одному и тому же рекламному объявлению одним и тем же пользователем в рамках одного показа",
            style: fontWeight,
        },
        sivtImpression: {
            metric: "SIVT impression",
            description: "Количество показов по SIVT (все категории)",
            style: fontWeight,
        },
        sivtPercent: {
            metric: "SIVT %",
            description: "(Количество показов по SIVT / Общее количество показов) x 100%",
            style: fontWeight,
        },
        sivtClicks: {
            metric: "SIVT clicks",
            description: "Количество кликов по SIVT",
            style: fontWeight,
        },
        hiddenImpressions: {
            metric: "Hidden impressions",
            description: "Количество показов, при которых реклама перекрывается, становится прозрачной или скрывается за элементами страницы",
            style: fontWeight,
        },
        hiddenClicks: {
            metric: "Hidden clicks",
            description: "Количество кликов, при которых реклама перекрывается, становится прозрачной или скрывается за элементами страницы",
            style: fontWeight,
        },
        hiddenImpressionsRate: {
            metric: "Hidden impressions rate",
            description: "(Количество показов, в которых объявления перекрываются, становятся прозрачными или скрываются за элементами страницы/Общее количество показов) x 100%",
            style: fontWeight,
        },
        hiddenClicksRate: {
            metric: "Hidden clicks rate",
            description: "(Количество кликов, при которых реклама перекрывается, становится прозрачной или скрывается за элементами страницы/Общее количество кликов) x 100%",
            style: fontWeight,
        },
        badExternalTrafficImpressions: {
            metric: "Bad external traffic impressions",
            description: "Количество показов с трафиком, не связанным с людьми, от мошеннических поставщиков трафика",
            style: fontWeight,
        },
        badExternalTrafficImpressionsRate: {
            metric: "Bad external traffic impressions rate",
            description: "(Количество показов с нечеловеческим трафиком, поступившим от мошеннических поставщиков трафика/Общее количество показов) x 100%",
            style: fontWeight,
        },
        badExternalTrafficClicks: {
            metric: "Bad external traffic clicks",
            description: "Количество кликов с нечеловеческим трафиком, поступившим от мошеннических поставщиков трафика",
            style: fontWeight,
        },
        badExternalTrafficClicksRate: {
            metric: "Bad external traffic clicks rate",
            description: "(Количество кликов с нечеловеческим трафиком, поступившим от мошеннических поставщиков трафика/Общее количество кликов) x 100%",
            style: fontWeight,
        },
        badAutorefresh: {
            metric: "Bad autorefresh",
            description: "Количество показов с автоматическим обновлением страницы или рекламного контейнера каждые 3-10 секунд. Такая частота считается мошеннической.",
            style: fontWeight,
        },
        badAutorefreshRate: {
            metric: "Bad autorefresh rate",
            description: "(Количество показов с автоматическим обновлением страницы или рекламного контейнера каждые 3-10 секунд/Общее количество показов) x 100%",
            style: fontWeight,
        },
        highAdDensityImpressions: {
            metric: "High ad density impressions",
            description: "Количество показов и посещаемость страниц, на которых реклама занимает более 30% пикселей, считаются страницами с высокой плотностью рекламы. Плотность рекламы на страницах должна составлять менее 30%.",
            style: fontWeight,
        },
        highAdDensityImpressionsRate: {
            metric: "High ad density impressions rate",
            description: "(Количество показов с трафиком со страниц, на которых реклама занимает более 30% пикселей, считается страницами с высокой плотностью рекламы/Общее количество показов) x 100%",
            style: fontWeight,
        },
        highAdDensityClicks: {
            metric: "High ad density clicks",
            description: "Количество кликов с трафиком со страниц, на которых реклама занимает более 30% пикселей, считается страницами с высокой плотностью рекламы. На страницах с высокой плотностью рекламы должно быть менее 30%.",
            style: fontWeight,
        },
        highAdDensityClicksRate: {
            metric: "High ad density clicks rate",
            description: "(Количество кликов по трафику со страниц, на которых реклама занимает более 30% пикселей, считается страницами с высокой плотностью рекламы/Общее количество кликов) x 100%",
            style: fontWeight,
        },
        ghostAdCallImpressions: {
            metric: "Ghost ad call impressions",
            description: "Количество показов с процентом поддельных рекламных запросов (объявление обновляется в течение 3 секунд с момента предыдущего показа)",
            style: fontWeight,
        },
        ghostAdCallImpressionsRate: {
            metric: "Ghost ad call impressions rate",
            description: "(Количество показов с процентом поддельных рекламных запросов (объявление обновляется в течение 3 секунд с момента предыдущего показа)/Общее количество показов) x 100%",
            style: fontWeight,
        },
        ghostAdCallClicks: {
            metric: "Ghost ad call clicks",
            description: "Количество кликов с процентом запросов на поддельную рекламу (объявление обновляется в течение 3 секунд с момента предыдущего показа)",
            style: fontWeight,
        },
        ghostAdCallClicksRate: {
            metric: "Ghost ad call clicks rate",
            description: "(Количество показов с процентом поддельных рекламных запросов (объявление обновляется в течение 3 секунд с момента предыдущего показа)/Общее количество кликов) x 100%",
            style: fontWeight,
        },
        decisionImpressions: {
            metric: "Decision impressions",
            description: "Количество показов, по которым был доступен замер фрода",
            style: fontWeight,
        },
        decisionClicks: {
            metric: "Decision clicks",
            description: "Количество кликов, по которым был доступен замер фрода",
            style: fontWeight,
        },
        decisionConversions: {
            metric: "Decision conversions",
            description: "Количество конверсий, по которым был доступен замер фрода",
            style: fontWeight,
        },
    },
    brandSafety: {
        ImpressionsWithEnabledBS: {
            metric: "Impressions with enabled BS",
            description: "Количество показов, по которым была активирована функция brand safety",
            style: fontWeight,
        },
        BSTotal: {
            metric: "BS total",
            description: "Количество показов, по которым было попадание в BS firewall ИЛИ BS Illegal (пересечение)",
            style: fontWeight,
        },
        BSDecisionImpression: {
            metric: "BS decision impression",
            description: "Количество показов, по которым пришли метаданные (title, description, meta, keywords)",
            style: fontWeight,
        },
        Firewall: {
            metric: "Firewall",
            description: "Количество показов, входящих в какую-либо категорию BS по метаданным",
            style: fontWeight,
        },
        FirewallPercent: {
            metric: "Firewall %",
            description: "Отношение Firewall к BS decision impression",
            style: fontWeight,
        },
        AlcoholDrugs: {
            metric: "Alcohol/Drugs",
            description: "Количество показов, относящихся к категории Алкоголь/Запрещенные вещества",
            style: fontWeight,
        },
        AlcoholDrugsRate: {
            metric: "Alcohol/Drugs rate",
            description: "Отношение количества показов в категории Алкоголь/Запрещенные вещества к BS decision impression",
            style: fontWeight,
        },
        Adult: {
            metric: "Adult",
            description: "Количество показов, относящихся к категории Контент 18+",
            style: fontWeight,
        },
        AdultRate: {
            metric: "Adult rate",
            description: "Отношение количества показов в категории Контент 18+ к BS decision impression",
            style: fontWeight,
        },
        KeywordBlocking: {
            metric: "Keyword blocking",
            description: "Количество показов, относящихся к категории Ключевые слова (кастомный список клиента)",
            style: fontWeight,
        },
        KeywordBlockingRate: {
            metric: "Keyword blocking rate",
            description: "Отношение количества показов в категории Ключевые слова к BS decision impression",
            style: fontWeight,
        },
        Discrimination: {
            metric: "Discrimination",
            description: "Количество показов, относящихся к категории Дискриминация",
            style: fontWeight,
        },
        DiscriminationRate: {
            metric: "Discrimination rate",
            description: "Отношение количества показов в категории Дискриминация к BS decision impression",
            style: fontWeight,
        },
        FakeNews: {
            metric: "Fake news",
            description: "Количество показов, относящихся к категории Фейковые новости",
            style: fontWeight,
        },
        FakeNewsRate: {
            metric: "Fake news rate",
            description: "Отношение количества показов в категории Фейковые новости к BS decision impression",
            style: fontWeight,
        },
        PirateWebsites: {
            metric: "Pirate websites",
            description: "Количество показов, относящихся к категории Пиратские веб-сайты",
            style: fontWeight,
        },
        PirateWebsitesRate: {
            metric: "Pirate websites rate",
            description: "Отношение количества показов в категории Пиратские веб-сайты к BS decision impression",
            style: fontWeight,
        },
        ProhibitedContent: {
            metric: "Prohibited content",
            description: "Количество показов, относящихся к категории Запрещенный контент",
            style: fontWeight,
        },
        ProhibitedContentRate: {
            metric: "Prohibited content rate",
            description: "Отношение количества показов в категории Запрещенный контент к BS decision impression",
            style: fontWeight,
        },
        ViolenceWeapons: {
            metric: "Violence/weapons",
            description: "Количество показов, относящихся к категории Насилие/Оружие",
            style: fontWeight,
        },
        ViolenceWeaponsRate: {
            metric: "Violence/weapons rate",
            description: "Отношение количества показов в категории Насилие/Оружие к BS decision impression",
            style: fontWeight,
        },
        Borderline: {
            metric: "Borderline",
            description: "Количество показов, относящихся к категории Пограничный контент",
            style: fontWeight,
        },
        BorderlineRate: {
            metric: "Borderline rate",
            description: "Отношение количества показов в категории Пограничный контент к BS decision impression",
            style: fontWeight,
        },
        BSIllegal : {
            metric: "BS Illegal ",
            description: `Количество URL, которые попали в BlackList.

                        Illegal  - это категория для сайтов, приложений и отдельных страниц/разделов, основной функционал или существенная часть контента которых связаны с предоставлением, распространением, продажей, организацией либо практическим содействием деятельности, запрещённой законом, включая нарушение прав третьих лиц.

                        - Pirate films: Пиратские фильмы, сериалы, музыка, книги, ПО; нелегальные IPTV/стриминговые сервисы
                        - Torrents:Торренты/P2P/warez и другие сервисы, ориентированные на распространение нелегальных копий
                        - Non-licensed: Распространение нелицензионного ПО
                        - illegal access: Практические инструкции, инструменты или сервисы для неправомерного доступа, взлома, кражи данных
                        - Prohibited URL: Домен/app, признанный незаконным или запрещённым компетентным органом применимой юрисдикции
                        - Other forbedden activity: Иная деятельность, явно запрещённая применимым законодательством`,
            style: fontWeight,
        },
        bSIllegalRate : {
            metric: "BS Illegal rate ",
            description: "Количество показов с BS Illegal к общему количеству показов с включенным BS (Impressions with enabled BS)",
            style: fontWeight,
        },
    },
    analytics: {
        visitsPostClick: {
            metric: "Visits (post click)",
            description: "Количество посещений веб-сайта",
            style: fontWeight,
        },
        pagesViews: {
            metric: "Pages views",
            description: "Количество страниц, просмотренных на сайте рекламодателя после клика",
            style: fontWeight,
        },
        dailyUniqueUsersOnSite: {
            metric: "Daily U.U. (Site) (Daily unique users on site)",
            description: "Сумма уникальных пользователей, ежедневно посещавших сайт рекламодателя после клика",
            style: fontWeight,
        },
        uniqueUsersOnSite: {
            metric: "U.U. (Site) ( Unique users on site)",
            description: "Количество уникальных пользователей (файлов cookie), посетивших веб-сайт рекламодателя после клика с начала кампании, если продолжительность кампании составляет до 90 дней, или сумма уникальных пользователей за месяц, посетивших веб-сайт рекламодателя после клика, если продолжительность кампании превышает 90 дней, или неизвестно (дата окончания кампании отсутствует)",
            style: fontWeight,
        },
        pageViewsOnSitePerVisit: {
            metric: "Page views on site per visit",
            description: "Количество страниц, которые пользователь посещает за сессию",
            style: fontWeight,
        },
        costPerPageViewsOnSite: {
            metric: "Cost per page views on site",
            description: "Стоимость за количество просмотров страницы",
            style: fontWeight,
        },
        bounceRate: {
            metric: "Bounce rate",
            description: "Процент посещений одной страницы по отношению к общему числу посещений",
            style: fontWeight,
        },
        averageTimeSpentOnSite: {
            metric: "Average time spent on site",
            description: "Среднее время, которое пользователь проводит на веб-сайте во время сессии",
            style: fontWeight,
        },
    },
    mediaBudget: {
        revenues: {
            metric: "Revenues",
            description: "Общая сумма дохода. Этот показатель доступен, если в WCM задан параметр «Amount» (Сумма) в теге конверсии. Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        totalItems: {
            metric: "Total items",
            description: "Общее количество приобретенных товаров. Этот показатель доступен, если в WCM установлен параметр «Quantity» (количество) в теге конверсии. Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        totalCost: {
            metric: "Total cost",
            description: "Общие расходы рекламодателя. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании. Он может быть равен общему установленному бюджету или рассчитан исходя из цены приобретенной единицы рекламы.",
            style: fontWeight,
        },
        averageCart: {
            metric: "Average cart",
            description: "Средняя сумма покупки. Этот показатель доступен, если в WCM заданы параметры «Amount» (Сумма) и «Quantity» (количество) в теге конверсии. Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        cpa: {
            metric: "CPA",
            description: "Отношение общей стоимости к количеству конверсий. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.  Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        cpm: {
            metric: "CPM",
            description: "Стоимость за 1000 показов. (Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании).",
            style: fontWeight,
        },
        cpc: {
            metric: "CPC",
            description: "Стоимость клика. (Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.)",
            style: fontWeight,
        },
        cpv: {
            metric: "CPV",
            description: "Стоимость за 1000 просмотров (Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании).",
            style: fontWeight,
        },
        purchasedVolume: {
            metric: "Purchased volume",
            description: "Количество показов/кликов/конверсий/покупок, совершенных рекламодателем. Чтобы эта информация отображалась в разделе отчетов, ее необходимо настроить в параметрах кампании (см. документацию инструмента).",
            style: fontWeight,
        },
        effectiveCost: {
            metric: "Effective cost",
            description: "Общая стоимость, деленная на объем показов (для CPM) или кликов (для CPC). Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.",
            style: fontWeight,
        },
        effectiveCostPerConversion: {
            metric: "Effective cost per conversion",
            description: "Коэффициент отношения общей эффективной стоимости (количество показов или кликов, умноженное на эффективную CPM или CPC) к количеству конверсий. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании. Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        costPerConversion: {
            metric: "Cost / conv. (Cost per conversion)",
            description: "Отношение общей стоимости к количеству конверсий. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании. Может быть разделен на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        costPerPagesViews: {
            metric: "Cost / pages views (Cost per pages views)",
            description: "Отношение общей стоимости к количеству просмотров страниц. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.",
            style: fontWeight,
        },
        costPerDailyUniqueUsersOnSite: {
            metric: "Cost / daily UU ( Site) (Cost per daily unique users on site)",
            description: "Отношение общей стоимости к количеству уникальных пользователей сайта в день. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.",
            style: fontWeight,
        },
        costPerUniqueUsersOnSite: {
            metric: "Cost / UU (Site) (Cost per unique users on site)",
            description: "Отношение общей стоимости к количеству уникальных пользователей на сайте. Этот показатель доступен в разделе отчетов только в том случае, если стоимость была настроена в параметрах кампании.",
            style: fontWeight,
        },
    },
    richMedia: {
        impressionsWithExpands: {
            metric: "Imp. with expands (Impressions with expands)",
            description: "Количество показов, в которых объявление было раскрыто хотя бы один раз.",
            style: fontWeight,
        },
        impressionsWithExpandsRate: {
            metric: "Imp. with expands rate (Impressions with expands rate)",
            description: "Доля показов, в которых объявление было раскрыто хотя бы один раз.",
            style: fontWeight,
        },
        expands: {
            metric: "Expands",
            description: "Общее количество раскрытий объявления.",
            style: fontWeight,
        },
        expandRate: {
            metric: "Expand rate",
            description: "Доля раскрытий объявления относительно общего количества показов.",
            style: fontWeight,
        },
        expand1s: {
            metric: "Expand 1s",
            description: "Доля раскрытий, при которых объявление оставалось раскрытым не менее 1 секунды.",
            style: fontWeight,
        },
        dailyUniqueExpands: {
            metric: "Daily U.expands (Daily unique expands)",
            description: "Суммарное количество уникальных пользователей в день, которые раскрывали объявление.",
            style: fontWeight,
        },
        uniqueExpands: {
            metric: "U.expands (Unique expands)",
            description: "Количество уникальных пользователей (cookies), которые раскрывали объявление:- за весь период кампании, если её длительность до 90 дней; либо сумма месячных уникальных пользователей, если длительность кампании более 90 дней или неизвестна (дата окончания кампании не задана).",
            style: fontWeight,
        },
        events: {
            metric: "Events",
            description: "Количество раз, когда произошло событие.",
            style: fontWeight,
        },
        averageExpandTime: {
            metric: "Avg. Expand time (Average expand time)",
            description: "Среднее время расхлопа (в секундах).",
            style: fontWeight,
        },
    },
    confirmConversions: {
        confirmedConversions: {
            metric: "Confirmed conversions",
            description: "Количество конверсий, подтвержденных рекламодателем в WCM. Можно разделить на 4 типа в зависимости от типа конверсии, совершенной пользователями (конверсии после клика, после событий, после видимого показа, после показа).",
            style: fontWeight,
        },
        confirmedTotalRevenues: {
            metric: "Confirmed total revenues",
            description: "Общая сумма дохода от подтвержденных конверсий.",
            style: fontWeight,
        },
        confirmedTotalItems: {
            metric: "Confirmed total items",
            description: "Общее количество товаров, приобретенное в рамках подтвержденных конверсий.",
            style: fontWeight,
        },
        confirmedUntrackedConversions: {
            metric: "Confirmed untracked conversions",
            description: "Количество конверсий, подтвержденных рекламодателем в WCM, которые не были атрибуцированы к рекламной кампании.",
            style: fontWeight,
        },
        confirmedUntrackedConversionsItems: {
            metric: "Confirmed untracked conversions items",
            description: "Общее количество товаров, приобретенное в рамках подтвержденных конверсий, которые не были атрибуцированы к рекламной кампании.",
            style: fontWeight,
        },
        confirmedUntrackedConversionsRevenues: {
            metric: "Confirmed untracked conversions revenues",
            description: "Общая сумма дохода от подтвержденных конверсий, не атрибуцированных к данной рекламной кампании.",
            style: fontWeight,
        },
        unconfirmedConversions: {
            metric: "Unconfirmed conversions",
            description: "Количество конверсий, не подтвержденных рекламодателем в WCM.",
            style: fontWeight,
        },
        unconfirmedTotalRevenues: {
            metric: "Unconfirmed total revenues",
            description: "Общая сумма дохода от неподтвержденных конверсий.",
            style: fontWeight,
        },
        unconfirmedTotalItems: {
            metric: "Unconfirmed total items",
            description: "Общее количество товаров, приобретенное в рамках неподтвержденных конверсий.",
            style: fontWeight,
        },
        unconfirmedUntrackedConversions: {
            metric: "Unconfirmed untracked conversions",
            description: "Количество конверсий, не подтвержденных рекламодателем в WCM и не атрибуцированных к рекламной кампании.",
            style: fontWeight,
        },
        unconfirmedUntrackedConversionsRevenues: {
            metric: "Unconfirmed untracked conversions revenues",
            description: "Общая сумма дохода от неподтвержденных конверсий, не атрибуцированных к данной рекламной кампании.",
            style: fontWeight,
        },
        unconfirmedUntrackedConversionsItems: {
            metric: "Unconfirmed untracked conversions items",
            description: "Общее количество товаров, приобретенное в рамках неподтвержденных конверсий, которые не были атрибуцированы к рекламной кампании.",
            style: fontWeight,
        },
    }
};

export const metricsHeadingProps = {
    basic: {
        title: "Basic (основные показатели)",
        arrow: "⮟",
    },
    video: {
        title: "Video (видео)",
        arrow: "⮟",
    },
    performance: {
        title: "Performance (конверсии)",
        arrow: "⮟",
    },
    visibility: {
        title: "Visibility (видимость)",
        arrow: "⮟",
    },
    customEvents: {
        title: "Custom events (кастомные события)",
        arrow: "⮟",
    },
    verification: {
        title: "Verification (верификация)",
        arrow: "⮟",
    },
    brandSafety: {
        title: "Brand safety (замер безопасности окружения бренда)",
        arrow: "⮟",
    },
    analytics: {
        title: "Analytics (аналитика)",
        arrow: "⮟",
    },
    mediaBudget: {
        title: "Media budget (медиа бюджет)",
        arrow: "⮟",
    },
    richMedia: {
        title: "Rich media (rich media)",
        arrow: "⮟",
    },
    confirmConversions: {
        title: "Confirm conversions (подтверждённые конверсии)",
        arrow: "⮟",
    },
};

export const color = {
    red: "#c1002a",
};
